export default __webpack_public_path__ + "static/media/StudentIcon.112a16fa.svg";